import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import com.findyourbuddies.website.pages.HomePage as _com_findyourbuddies_website_pages_HomePage
import com.findyourbuddies.website.pages.PrivacyPolicyPage as _com_findyourbuddies_website_pages_PrivacyPolicyPage
import com.findyourbuddies.website.pages.TermsOfServicePage as _com_findyourbuddies_website_pages_TermsOfServicePage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Fyb Website"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _com_findyourbuddies_website_pages_HomePage()
        }
        ctx.router.register(
            "/privacy-policy",
        ) { pageCtx -> 
            _com_findyourbuddies_website_pages_PrivacyPolicyPage()
        }
        ctx.router.register(
            "/terms-of-service",
        ) { pageCtx -> 
            _com_findyourbuddies_website_pages_TermsOfServicePage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("waxe-text", com.findyourbuddies.website.styles.WaxeTextStyle)
        ctx.theme.registerStyle("comfortaa-text", com.findyourbuddies.website.styles.ComfortaaTextStyle)
        com.findyourbuddies.website.initStyles(ctx)
    }

    router.tryRoutingTo(BasePath.remove(window.location.href.removePrefix(window.origin)), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        com.findyourbuddies.website.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
